import React from 'react';
import { TextInput, required, SelectInput } from 'react-admin';
import { Grid } from '@material-ui/core/';
import DateInput from '../../core/components/forked/input/DateInput';
import {
  categoryTermStatus,
  categoryTermFrequency
} from './CategoryTermsLookups';
import RichTextInput from '../../core/components/inputs/RichTextInput';
import CheckBoxField from '../../core/components/CheckBoxField';
import { Typography } from '@material-ui/core';
import { isValidDate, formatDate } from '../../core/utils/index';
import { Field } from 'react-final-form';

const CategoryTermsSummary = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Typography variant="h5">Details</Typography>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <TextInput
          source="title"
          label="Category Term Name"
          validate={[required()]}
          options={{ autoComplete: 'off' }}
          variant="standard"
          autoFocus
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectInput
          source="status"
          label="Terms And Conditions Status"
          choices={categoryTermStatus}
          validate={[required()]}
          variant="standard"
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DateInput
          source="asOfDate"
          label="Start Date"
          validate={[required(), isValidDate]}
          options={{ autoComplete: 'off' }}
          variant="standard"
          helperText={false}
          placeholder="MM/dd/yyyy"
          customParseValue={formatDate}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SelectInput
          source="frequency"
          label="Display Frequency"
          choices={categoryTermFrequency}
          variant="standard"
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Field
          name="downloadAsPDF"
          component={CheckBoxField}
          label="Mandatory download of Terms and Conditions as PDF"
          variant="standard"
          type="checkbox"
        />
      </Grid>
      <Grid item xs={12}>
        <RichTextInput
          source="body"
          label="Content"
          displayingVariables={false}
        />
      </Grid>
    </Grid>
  );
};

export default CategoryTermsSummary;
